module.exports = __webpack_public_path__ + "static/media/04_BOJO_MEIA_TACA_ESTAMPADO_07.4888cd5b.jpg";